/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { getPlaylists, addPlaylist, deletePlaylist, getPlaylistItems, addPlaylistItem, removePlaylistItem, getContents } from '../api';

export default function Playlists() {
  const [playlists, setPlaylists] = useState([]);
  const [selected, setSelected] = useState(null);
  const [items, setItems] = useState([]);
  const [contents, setContents] = useState([]);
  const [newPl, setNewPl] = useState({ name: '', description: '' });
  const [showForm, setShowForm] = useState(false);
  const [view, setView] = useState('list');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const load = async () => {
    const res = await getPlaylists();
    setPlaylists(res.data);
    const c = await getContents();
    setContents(c.data);
  };

  const loadItems = async (id) => {
    const res = await getPlaylistItems(id);
    setItems(res.data);
  };

  useEffect(() => { load(); }, []);

  const handleSelect = (pl) => {
    setSelected(pl);
    loadItems(pl.id);
    if (isMobile) setView('detail');
  };

  const handleAdd = async () => {
    if (!newPl.name) return;
    await addPlaylist(newPl);
    setNewPl({ name: '', description: '' });
    setShowForm(false);
    load();
  };

  const addedIds = items.map(i => i.content_id);
  const available = contents.filter(c => !addedIds.includes(c.id));
  const typeIcon = { image: '🖼️', video: '🎬', url: '🌐', data: '📋', pdf: '📄' };

  const PlaylistList = (
    <div style={{ padding: '16px 20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1A1A1A' }}>Playlists</h2>
        <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>+ Create</button>
      </div>

      {showForm && (
        <div style={formCard}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
            <input placeholder="Playlist name *" value={newPl.name} onChange={e => setNewPl({ ...newPl, name: e.target.value })} style={{ ...inp, flex: '1 1 160px' }} />
            <input placeholder="Description" value={newPl.description} onChange={e => setNewPl({ ...newPl, description: e.target.value })} style={{ ...inp, flex: '1 1 160px' }} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleAdd} style={btnPrimary}>Create</button>
            <button onClick={() => setShowForm(false)} style={btnGhost}>Cancel</button>
          </div>
        </div>
      )}

      {playlists.length === 0 && !showForm && (
        <div style={{ background: '#fff', border: '1px dashed #E8E3DC', borderRadius: 10, padding: '32px', textAlign: 'center', color: '#aaa', fontSize: 14 }}>
          No playlists yet. Create one to start organising content.
        </div>
      )}

      {playlists.map(pl => (
        <div key={pl.id}
          style={{ ...plCard, border: selected?.id === pl.id ? '1.5px solid #8B1E2D' : '1px solid #E8E3DC', background: selected?.id === pl.id ? '#FDF5F6' : '#fff', cursor: 'pointer' }}
          onClick={() => handleSelect(pl)}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1A1A1A' }}>{pl.name}</div>
              {pl.description && <div style={{ fontSize: 12, color: '#aaa', marginTop: 3 }}>{pl.description}</div>}
            </div>
            <div style={{ display: 'flex', gap: 6 }} onClick={e => e.stopPropagation()}>
              <button onClick={() => handleSelect(pl)} style={btnSecondary}>Edit</button>
              <button onClick={() => deletePlaylist(pl.id).then(load)} style={btnDanger}>Delete</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  const PlaylistDetail = (
    <div style={{ padding: '16px 20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        {isMobile && <button onClick={() => setView('list')} style={btnGhost}>← Back</button>}
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1A1A1A' }}>{selected?.name}</h3>
      </div>

      {/* Current items */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Content order ({items.length})</div>
        {items.length === 0 && (
          <div style={{ background: '#FAFAF9', border: '1px dashed #E8E3DC', borderRadius: 8, padding: '16px', textAlign: 'center', color: '#aaa', fontSize: 13 }}>
            No content yet. Add items from below.
          </div>
        )}
        {items.map((item, i) => (
          <div key={item.id} style={{ background: '#fff', border: '1px solid #E8E3DC', borderRadius: 8, padding: '10px 14px', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 1px 2px rgba(0,0,0,0.03)' }}>
            <span style={{ color: '#ccc', fontSize: 12, minWidth: 18, textAlign: 'center', fontWeight: 600 }}>{i + 1}</span>
            <span style={{ fontSize: 16 }}>{typeIcon[item.contents?.type] || '📄'}</span>
            <span style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#1A1A1A' }}>{item.contents?.name}</span>
            <span style={{ fontSize: 11, color: '#aaa', background: '#F5F3F0', padding: '2px 7px', borderRadius: 20 }}>{item.contents?.duration_sec}s</span>
            <button onClick={() => removePlaylistItem(selected.id, item.content_id).then(() => loadItems(selected.id))} style={btnDanger}>Remove</button>
          </div>
        ))}
      </div>

      {/* Available to add */}
      {available.length > 0 && (
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Add content</div>
          {available.map(c => (
            <div key={c.id} style={{ background: '#FAFAF9', border: '1px solid #E8E3DC', borderRadius: 8, padding: '9px 14px', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 16 }}>{typeIcon[c.type] || '📄'}</span>
              <span style={{ flex: 1, fontSize: 13, color: '#555' }}>{c.name}</span>
              <span style={{ fontSize: 11, color: '#aaa', background: '#eee', padding: '2px 7px', borderRadius: 20 }}>{c.duration_sec}s</span>
              <button onClick={() => addPlaylistItem(selected.id, c.id).then(() => loadItems(selected.id))}
                style={btnSecondary}>+ Add</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ background: '#F8F6F3', minHeight: '100%' }}>
        <div style={hdr}>
          <h1 style={{ fontSize: 18, fontWeight: 700, color: '#1A1A1A', margin: 0 }}>Playlists</h1>
        </div>
        {view === 'list' ? PlaylistList : PlaylistDetail}
      </div>
    );
  }

  return (
    <div style={{ background: '#F8F6F3', minHeight: '100%' }}>
      <div style={hdr}>
        <h1 style={{ fontSize: 18, fontWeight: 700, color: '#1A1A1A', margin: 0 }}>Playlists</h1>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', minHeight: 'calc(100% - 53px)' }}>
        <div style={{ borderRight: '1px solid #E8E3DC' }}>{PlaylistList}</div>
        <div>{selected ? PlaylistDetail : <div style={{ padding: 40, textAlign: 'center', color: '#aaa', fontSize: 14 }}>← Select a playlist to edit it</div>}</div>
      </div>
    </div>
  );
}

const hdr = { background: '#fff', borderBottom: '1px solid #E8E3DC', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 10 };
const btnPrimary = { background: '#8B1E2D', color: '#fff', border: 'none', borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const btnSecondary = { background: '#fff', color: '#444', border: '1px solid #E8E3DC', borderRadius: 7, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer' };
const btnDanger = { background: '#fff', color: '#9B2335', border: '1px solid #F5C6CB', borderRadius: 7, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer' };
const btnGhost = { background: 'none', color: '#888', border: '1px solid #E8E3DC', borderRadius: 8, padding: '7px 12px', fontSize: 12, cursor: 'pointer' };
const inp = { width: '100%', padding: '8px 12px', border: '1px solid #E8E3DC', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#FAFAF9' };
const formCard = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, padding: '14px', marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const plCard = { borderRadius: 10, padding: '12px 14px', marginBottom: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.04)', transition: 'border-color 0.15s' };